import { render, staticRenderFns } from "./standard-rate.vue?vue&type=template&id=f3b9d73a&"
import script from "./standard-rate.vue?vue&type=script&lang=js&"
export * from "./standard-rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports